module.exports = __webpack_public_path__ + "img/horizontal_4_1_pp1_5010.dc65c793.png";